<template>
  <div class="content-warp">
    <div class="spin-warp" v-if="showSpinning">
      <a-spin
        :tip="$t('devicesManaConfig.getingDeviceConfig')"
        size="large"
      ></a-spin>
    </div>

    <div class="spin-warp" v-if="showSubmitSpinning">
      <a-spin
        :tip="$t('devicesManaConfig.submitingDeviceConfig')"
        size="large"
      ></a-spin>
    </div>

    <a-row
      class="base-info-card"
      type="flex"
      justify="space-between"
      align="middle"
    >
      <a-col :span="4" style="padding-top: 16px;">
        <h4 style="font-size: 24px;">
          {{ $t('devicesManaConfig.deviceName') }}
        </h4>
        <p class="device-name" style="font-size: 16px;">{{ device.name }}</p>
      </a-col>
      <a-col :span="16" style="padding-top: 16px;">
        <a-descriptions>
          <a-descriptions-item :label="$t('devicesManaConfig.deviceOrg')">
            {{ device.deptName }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('devicesManaConfig.deviceStauts')">
            {{ device.status }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('devicesManaConfig.deviceVersion')">
            {{ device.version }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('devicesManaConfig.deviceAuthCount')">
            {{ device.personCount || 0 }} 人
          </a-descriptions-item>
          <a-descriptions-item :label="$t('devicesManaConfig.deviceType')">
            {{ device.typeName }}
          </a-descriptions-item>
        </a-descriptions>
      </a-col>
      <a-col :span="2" style="padding: 16px 0;">
        <a-button
          type="primary"
          @click="
            () => {
              editDeviceModalVisible = true
            }
          "
          >{{ $t('devicesManaConfig.editBtn') }}</a-button
        >
      </a-col>
    </a-row>
    <!-- 访客一体机配置 -->
    <div class="bg-white" style="margin-top:16px" v-if="device.type === '102'">
      <a-form
        :form="visitorConfigForm"
        @submit.prevent="handleVisitorConfigSubmit"
      >
        <a-row class="content-panle margin-0" :gutter="30">
          <a-col :span="24" class="padding-tb-md">
            <h3 class="panle-head">
              {{ $t('devicesManaConfig.visitorMachineConfigTitle') }}
            </h3>
            <!-- 访客最长授权时间 -->
            <a-col :span="8">
              <a-form-item
                :label="$t('devicesManaConfig.maximumAuthorizedTimeTxt')"
              >
                <a-input
                  :suffix="$t('devicesManaConfig.maximumAuthorizedTimUnit')"
                  v-decorator="[
                    'maxAuthedTime',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t(
                            'devicesManaConfig.maximumAuthorizedTimeBlank'
                          )
                        },
                        {
                          pattern: /^[1-9]\d*$/,
                          message: $t(
                            'devicesManaConfig.maximumAuthorizedTimeWarning'
                          )
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </a-col>
            <!-- 访客证件类型 -->
            <a-col :span="8">
              <a-form-item :label="$t('devicesManaConfig.IDType')">
                <a-select
                  dropdownClassName="form-select"
                  :getPopupContainer="trigger => trigger.parentNode"
                  :placeholder="$t('devicesManaConfig.IDTypeTxt')"
                  :options="enumsData.idType"
                  mode="multiple"
                  :labelInValue="true"
                  @change="handleIdTypeChange"
                  v-decorator="[
                    'visitorIdTypes',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('devicesManaConfig.IDTypeBlank')
                        }
                      ],
                      validateTrigger: ['change', 'blur']
                    }
                  ]"
                />
              </a-form-item>
            </a-col>
            <!-- 拜访事由-->
            <a-col :span="8">
              <a-form-item :label="$t('devicesManaConfig.visitReason')">
                <a-select
                  dropdownClassName="form-select"
                  :getPopupContainer="trigger => trigger.parentNode"
                  :placeholder="$t('devicesManaConfig.visitReasonTxt')"
                  :options="visitReasonOptions"
                  mode="multiple"
                  :labelInValue="true"
                  @change="resons => (visitReasons = resons)"
                  v-decorator="[
                    'visitReasons',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t('devicesManaConfig.visitReasonBlank')
                        }
                      ],
                      validateTrigger: ['change', 'blur']
                    }
                  ]"
                />
              </a-form-item>
            </a-col>
            <!-- 系统内人员不允许做为访客 -->
            <a-col :span="8">
              <a-form-item :label="$t('devicesManaConfig.personCantBeVisitor')">
                <a-select
                  dropdownClassName="form-select"
                  :getPopupContainer="trigger => trigger.parentNode"
                  v-decorator="[
                    'personAllowedVisit',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t(
                            'devicesManaConfig.personCantBeVisitorBlank'
                          )
                        }
                      ]
                    }
                  ]"
                >
                  <a-select-option value="true">{{
                    $t('devicesManaConfig.option_true')
                  }}</a-select-option>
                  <a-select-option value="false">{{
                    $t('devicesManaConfig.options_false')
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <!-- 拜访事由是否允许终端一体机配置 -->
            <a-col :span="8">
              <a-form-item
                :label="$t('devicesManaConfig.visitorReasonAllowedEdit')"
              >
                <a-select
                  dropdownClassName="form-select"
                  :getPopupContainer="trigger => trigger.parentNode"
                  v-decorator="[
                    'visitorReasonAllowedEdit',
                    {
                      rules: [
                        {
                          required: true,
                          message: $t(
                            'devicesManaConfig.visitorReasonAllowedEditBlank'
                          )
                        }
                      ]
                    }
                  ]"
                >
                  <a-select-option value="true">{{
                    $t('devicesManaConfig.option_true')
                  }}</a-select-option>
                  <a-select-option value="false">{{
                    $t('devicesManaConfig.options_false')
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-col>
        </a-row>
        <a-row class="content-panle" style="margin-top: 16px;">
          <a-col :span="24" :style="{ textAlign: 'right' }">
            <a-button type="primary" html-type="submit" :loading="submitting">{{
              $t('devicesManaConfig.submitBtn')
            }}</a-button>
            <a-button :style="{ marginLeft: '8px' }" @click="handleBackList">{{
              $t('devicesManaConfig.backBtn')
            }}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 门禁一体机配置 -->
    <div class="menu-tab-warp bg-white" v-if="device.type === '101'">
      <div class="menu-tab-left">
        <a-menu
          mode="inline"
          :style="{ border: '0', width: 'auto' }"
          :selectedKeys="[selectedKey]"
          type="inner"
          @click="
            item => {
              selectedKey = item.key
            }
          "
        >
          <a-menu-item key="终端配置">{{
            $t('devicesManaConfig.menuTerminal')
          }}</a-menu-item>
          <a-menu-item key="门禁设置">{{
            $t('devicesManaConfig.menuGate')
          }}</a-menu-item>
          <a-menu-item key="识别设置">{{
            $t('devicesManaConfig.menuRecognizer')
          }}</a-menu-item>
          <a-menu-item key="预警设置">{{
            $t('devicesManaConfig.menuWarning')
          }}</a-menu-item>
          <a-menu-item key="门禁有效时间">{{
            $t('devicesManaConfig.menuActiveTime')
          }}</a-menu-item>
        </a-menu>
      </div>
      <div class="menu-tab-right">
        <keep-alive v-if="deviceConfig && !showSpinning">
          <!-- 终端配置 -->
          <TerminalSettingForm
            v-if="selectedKey === '终端配置'"
            :deviceConfig="deviceConfig"
            :deviceId="device.id"
            @submitConfig="handleSubmitConfig"
            @backList="handleBackList"
          ></TerminalSettingForm>

          <!-- 门禁设置 -->
          <GateSettingForm
            v-if="selectedKey === '门禁设置'"
            :deviceConfig="deviceConfig"
            :deviceId="device.id"
            :signIn="device.signIn"
            @submitConfig="handleSubmitConfig"
            @backList="handleBackList"
          ></GateSettingForm>

          <!-- 识别设置 -->
          <RecognizerSettingForm
            v-if="selectedKey === '识别设置'"
            :deviceConfig="deviceConfig"
            :deviceId="device.id"
            @submitConfig="handleSubmitConfig"
            @backList="handleBackList"
          ></RecognizerSettingForm>

          <!-- 预警设置 -->
          <WarningSettingForm
            v-if="selectedKey === '预警设置'"
            :deviceConfig="deviceConfig"
            :deviceId="device.id"
            @submitConfig="handleSubmitConfig"
            @backList="handleBackList"
          ></WarningSettingForm>

          <!-- 门禁有效时间 -->
          <ActiveTimeSettingForm
            v-if="selectedKey === '门禁有效时间'"
            :deviceConfig="deviceConfig"
            :deviceId="device.id"
            @submitConfig="handleSubmitConfig"
            @backList="handleBackList"
          ></ActiveTimeSettingForm>
        </keep-alive>
      </div>
    </div>

    <!-- 设置设备基本信息 -->
    <a-modal
      :title="$t('devicesManaConfig.editDeviceModalTitle')"
      :visible="editDeviceModalVisible"
      :okText="$t('devicesManaConfig.submitBtn')"
      :cancelText="$t('devicesManaConfig.cancelBtn')"
      @ok="handleEditDeviceOk"
      :confirmLoading="confirmDeviceLoading"
      @cancel="
        () => {
          editDeviceModalVisible = false
        }
      "
    >
      <a-form-model
        ref="editDeviceForm"
        :model="editDeviceForm"
        :rules="editDeviceFormRules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 18 }"
      >
        <a-form-model-item :label="$t('devicesManaConfig.deviceSN')">
          <p style="margin-bottom: 0">{{ device.SN }}</p>
        </a-form-model-item>
        <a-form-model-item :label="$t('devicesManaConfig.deviceType')">
          <p style="margin-bottom: 0">{{ device.typeName }}</p>
        </a-form-model-item>
        <a-form-model-item
          required
          :label="$t('devicesManaConfig.deviceOrg')"
          prop="deptId"
        >
          <a-select
            :placeholder="$t('devicesManaConfig.deviceOrgTxt')"
            :options="deptOptions"
            v-model="editDeviceForm.deptId"
          />
        </a-form-model-item>
        <a-form-model-item
          required
          :label="$t('devicesManaConfig.deviceName')"
          prop="name"
        >
          <a-input
            v-model="editDeviceForm.name"
            :placeholder="$t('devicesManaConfig.deviceNameTxt')"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import TerminalSettingForm from './config-form/TerminalSettingForm'
import GateSettingForm from './config-form/GateSettingForm'
import RecognizerSettingForm from './config-form/RecognizerSettingForm'
import WarningSettingForm from './config-form/WarningSettingForm'
import ActiveTimeSettingForm from './config-form/ActiveTimeSettingForm'

import { mapGetters, mapState } from 'vuex'
import {
  modifyDevice,
  getDeviceConfig,
  modifyDeviceConfig
} from '@/api/deviceMana'
import { getUserConfig } from '@/api/userMana'
import { setDeviceTimeConfig } from '@/api/timeConfig'

export default {
  name: 'devicesManaConfig',
  components: {
    TerminalSettingForm,
    GateSettingForm,
    RecognizerSettingForm,
    WarningSettingForm,
    ActiveTimeSettingForm
  },
  data() {
    return {
      showSpinning: true,
      showSubmitSpinning: false,

      device: {},
      deviceConfig: null,

      visitorConfigForm: this.$form.createForm(this),
      submitting: false,
      // defaultIdTypes: [],
      visitReasonOptions: [],

      selectedKey: '终端配置',

      // 编辑设备
      editDeviceModalVisible: false,
      confirmDeviceLoading: false,
      deptOptions: [],
      editDeviceForm: {
        deptId: undefined,
        name: undefined
      },
      editDeviceFormRules: this.getEditDeviceFormRules()
    }
  },
  computed: {
    ...mapState({
      lang: 'lang',
      enumsData: state => state.enumsStore.enumsData
    }),
    ...mapGetters(['orgAutoCompletedSourceData'])
  },
  watch: {
    lang: function(lang) {
      this.editDeviceFormRules = this.getEditDeviceFormRules()
    }
  },
  beforeCreate() {
    if (!this.$route.query.id) {
      this.$error({
        title: this.$t('devicesManaConfig.pageErrTitle'),
        content: this.$t('devicesManaConfig.pageErrContent'),
        okText: this.$t('devicesManaConfig.backBtn'),
        onOk: () => {
          this.$router.push({ name: 'devicesManaIndex' })
          setTimeout(() => {
            this.$multiTab.close('/devices-mana/config')
          }, 500)
        }
      })
    }
  },
  created() {
    // 创建机构选择项
    this.deptOptions = this.orgAutoCompletedSourceData.map(item => {
      return {
        title: item.name,
        value: item.id,
        key: item.id
      }
    })
  },
  async activated() {
    const newDevice = this.$route.query
    if (newDevice && newDevice.id !== this.device.id) {
      this.showSpinning = true

      this.device = newDevice
      this.editDeviceForm = {
        deptId: this.device.deptid,
        name: this.device.name
      }

      // 初始化访客一体机配置选项
      if (this.device.type === '102') { await this.initVisitorMachineConfigOptions() }
      // 获取设备配置
      this.getDeviceConfigInfo()
    }
  },
  methods: {
    getEditDeviceFormRules() {
      return {
        deptId: [
          {
            required: true,
            message: this.$t('devicesManaConfig.deviceOrgBlank'),
            trigger: ['blur', 'change']
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('devicesManaConfig.deviceNameBlank'),
            trigger: ['blur', 'change']
          },
          {
            max: 20,
            message: this.$t('devicesManaConfig.deviceNameWarning'),
            trigger: ['blur', 'change']
          }
        ]
      }
    },

    async initVisitorMachineConfigOptions() {
      try {
        // 访客一体机配置 默认访客证件类型
        // const defaultCard = this.enumsData.idType.find(t => t.key === 1) // 获取身份证
        // this.defaultIdTypes = { key: defaultCard.key, label: defaultCard.title }

        // 设置拜访理由选项
        const res = await getUserConfig()
        let { applyReasonList } = res.data.collection[0]
        applyReasonList = JSON.parse(applyReasonList)

        const options = []
        for (let key in applyReasonList) {
          options.push({
            title: applyReasonList[key],
            value: Number(key),
            key: Number(key)
          })
        }
        options.sort((prev, after) => prev.key - after.key)
        this.visitReasonOptions = options
      } catch (error) {}
    },

    // 获取设备所有配置
    async getDeviceConfigInfo() {
      try {
        const res = await getDeviceConfig({ id: this.device.id })
        const data = res.data.collection[0]

        // 门禁一体机
        if (this.device.type === '101') {
          data.standbyBrightnessValue = Number(data.standbyBrightnessValue)
          data.faceDetectDistance = Number(data.faceDetectDistance)
          data.faceDetectThreshold = Number(data.faceDetectThreshold)
          data.tempExceptValue =
            data.tempExceptValue && Number(data.tempExceptValue).toFixed(1)

          data.doorOpenMode =
            typeof data.doorOpenMode === 'string'
              ? JSON.parse(data.doorOpenMode)
              : data.doorOpenMode
          data.recognMode =
            typeof data.recognMode === 'string'
              ? JSON.parse(data.recognMode)
              : data.recognMode
          data.visitorRecognMode =
            typeof data.visitorRecognMode === 'string'
              ? JSON.parse(data.visitorRecognMode)
              : data.visitorRecognMode

          this.deviceConfig = data
        }
        // 访客一体机
        if (this.device.type === '102') {
          let visitorIdTypes =
            data.visitorIdTypes &&
            data.visitorIdTypes.map(t => ({ key: t.code, label: t.name }))
          // 无设置时设置默认选中所有选项
          visitorIdTypes =
            visitorIdTypes ||
            this.enumsData.idType.map(t => ({ key: t.key, label: t.title }))

          let visitReasons =
            data.visitReasons &&
            data.visitReasons.map(r => ({ key: r.code, label: r.name }))
          // 无设置时设置默认选中所有选项
          visitReasons =
            visitReasons ||
            this.visitReasonOptions.map(r => ({ key: r.key, label: r.title }))

          this.visitorConfigForm.setFieldsValue({
            maxAuthedTime: data.maxAuthedTime || 24,
            visitorIdTypes,
            visitReasons,
            personAllowedVisit:
              data.personAllowedVisit === undefined
                ? 'true'
                : String(data.personAllowedVisit),
            visitorReasonAllowedEdit:
              data.visitorReasonAllowedEdit === undefined
                ? 'true'
                : String(data.visitorReasonAllowedEdit)
          })
        }

        this.showSpinning = false
      } catch (error) {
        this.showSpinning = false
      }
    },

    // 提交门禁一体机配置
    async handleSubmitConfig(data) {
      // console.log('--devicesManaConfig handleSubmitConfig--', data)
      try {
        this.showSubmitSpinning = true
        if (data.type === 'setActiveTime') {
          // 提交门禁有效时间
          await setDeviceTimeConfig({
            deviceId: this.device.id,
            durationIds: data.values
          })
        } else {
          this.deviceConfig = Object.assign(this.deviceConfig, data)
          await modifyDeviceConfig(this.deviceConfig, this.device.id)
        }
        this.$notification.success({
          message: this.$t('devicesManaConfig.submitDeviceConfigSuccess'),
          description: ''
        })
        this.showSubmitSpinning = false
      } catch (error) {
        this.showSubmitSpinning = false
      }
    },
    // 提交访客一体机配置
    handleVisitorConfigSubmit() {
      this.visitorConfigForm.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.showSubmitSpinning = true
            this.submitting = true
            const config = {
              maxAuthedTime: values.maxAuthedTime,
              visitorIdTypes: values.visitorIdTypes.map(t => {
                return { code: t.key, name: t.label }
              }),
              visitReasons: values.visitReasons.map(r => {
                return { code: r.key, name: r.label }
              }),
              personAllowedVisit: values.personAllowedVisit === 'true',
              visitorReasonAllowedEdit:
                values.visitorReasonAllowedEdit === 'true'
            }
            await modifyDeviceConfig({ ...config }, this.device.id)
            this.$notification.success({
              message: this.$t('devicesManaConfig.submitDeviceConfigSuccess'),
              description: ''
            })
            this.showSubmitSpinning = false
            this.submitting = false
          } catch (error) {
            this.showSubmitSpinning = false
            this.submitting = false
          }
        }
      })
    },
    // 证件类型改变时
    handleIdTypeChange(types) {
      // if (types.every(t => t.key !== 1) || !types.length) {
      //   types.unshift(this.defaultIdTypes)
      // }
      // this.idTypes = types
    },

    // 返回列表
    handleBackList() {
      this.$multiTab.closeCurrentPage()
      this.$router.push({ name: 'devicesManaIndex' })
    },

    // 设备编辑信息
    handleEditDeviceOk() {
      this.$refs.editDeviceForm.validate(async valid => {
        if (valid) {
          try {
            this.confirmDeviceLoading = true
            await modifyDevice({
              id: this.device.id,
              deptId: this.editDeviceForm.deptId,
              deviceSn: this.device.SN,
              deviceTypeCode: Number(this.device.type),
              deviceName: this.editDeviceForm.name
            })
            this.$notification.success({
              message: this.$t('devicesManaConfig.editDeviceInfoSuccess'),
              description: ''
            })

            this.device = {
              ...this.device,
              ...this.editDeviceForm,
              deptName: this.deptOptions.filter(
                item => item.id === this.editDeviceForm.deptId
              ).title
            }

            this.editDeviceModalVisible = false
            this.confirmDeviceLoading = false
          } catch (error) {
            this.confirmDeviceLoading = false
          }
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.spin-warp {
  text-align: center;
  // background: rgba(230,247,255, 0.7);
  background: rgba(255, 255, 255, 0.6);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}
.spin-warp .ant-spin {
  top: 50%;
  position: absolute;
  margin-top: -30px;
}
.base-info-card {
  box-shadow: 0 0 20px #e8e8e8;
  border-radius: 5px;
  background-color: #fff;
  padding: 0 30px;
}
.base-info-card .ant-col {
  padding-top: 16px;
}
.base-info-card .device-name {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.config-panle {
  background-color: #fff;
  margin-top: 16px;
  box-shadow: 0 0 20px #e8e8e8;
  border-radius: 5px;
}

.menu-tab-warp {
  width: 100%;
  display: flex;
  margin-top: 16px;
  // height: 100%;
  // overflow: auto;
  padding: 16px 0;

  .menu-tab-left {
    border-right: 1px solid #e8e8e8;
    width: 224px;

    .ant-menu-item {
      text-align: center;
    }
  }

  .menu-tab-right {
    flex: 1 1;
  }
}
</style>
